// src/components/Footer.js
import React from "react";

const Footer = () => (
  <footer className="mono">
    <span>Andrew Rise · Vancouver</span>
    <span>© {new Date().getFullYear()}</span>
  </footer>
);

export default Footer;
